import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const useOrderResponse = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [qrData, setQrData] = useState(null);
  const [isQrModalOpen, setIsQrModalOpen] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const processOrderResponse = (response) => {
    try {
      const { transaction, type, data, message } = response;
      
      // Handle based on response type
      switch (type) {
        case 'none':
          // Simply redirect to success page
          navigate('/order-success', { 
            state: { 
              transactionId: transaction.id,
              reference: transaction.reference 
            } 
          });
          break;
          
        case 'redirect':
          // Show notification and redirect to external payment page
          if (data && data.url) {
            // You can implement a notification system here or use an existing one
            alert(t('checkout.redirect_payment_message'));
            window.location.href = data.url;
          } else {
            console.error('Missing redirect URL in response data');
          }
          break;
          
        case 'qr':
          // Display QR modal
          if (data && data.qr_image) {
            setQrData(data);
            setIsQrModalOpen(true);
          } else {
            console.error('Missing QR image in response data');
          }
          break;
          
        case 'info':
          // Redirect to info page with the data
          navigate('/order-info', {
            state: {
              transactionId: transaction.id,
              reference: transaction.reference,
              infoData: data
            }
          });
          break;
          
        default:
          console.error('Unknown response type:', type);
          break;
      }
    } catch (error) {
      console.error('Error processing order response:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const placeOrder = async (postFunction, onClearCart) => {
    setIsLoading(true);
    try {
      const response = await postFunction('/api/orders');
      processOrderResponse(response.data.payform);
      if (onClearCart) onClearCart();
      return response;
    } catch (error) {
      console.error('Error placing order:', error);
      setIsLoading(false);
      throw error;
    }
  };

  const closeQrModal = () => {
    setIsQrModalOpen(false);
    setQrData(null);
  };

  return {
    processOrderResponse,
    placeOrder,
    isLoading,
    qrData,
    isQrModalOpen,
    closeQrModal
  };
}; 